export default function Footer() {
  return (
    <footer className="w-full">
      <div className="mx-auto px-4 sm:px-6">

        {/* Top area: Blocks */}
        <div className="grid sm:grid-cols-1 gap-8 py-4 md:py-4 border-t border-gray-900 border-opacity-20">

          {/* 1st block */}
          <div className="items-end ml-4">
            <div className="flex align-end justify-end mx-auto">
                <h1 className='ml-2 mb-1 text-1xl font-bold text-white text-opacity-50'>© 2023</h1>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
